export const CIRCLE_COMMUNITY_URL = 'https://community.paritynow.co';

/**
 * Circle's headless session login: handing a member access token to this endpoint sets
 * Circle's own session cookie and drops the user into the community.
 *
 * Used to complete Circle login for a Clerk-authenticated user. The OAuth /o/authorize/ flow
 * relies on a backend Django session, which Clerk never establishes (and on the cross-apex
 * .com deploy the top-level authorize navigation can't carry the Clerk session anyway), so we
 * mint a Circle token via /circle-token and hand off here instead.
 */
export const getCircleSessionUrl = (accessToken: string) =>
  `${CIRCLE_COMMUNITY_URL}/session/cookies?access_token=${accessToken}`;
